module.exports = __webpack_public_path__ + "img/default-avatar.9677c28.png";